import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService, SharedService, SeoServiceService} from '../service/index';
import { OwlOptions } from 'ngx-owl-carousel-o';


import { contactForm } from '../forms'
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ReCaptchaV3Service } from 'ngx-captcha';

declare let $: any;
declare let jQuery: any;

@Component({
  selector: 'app-customer-service',
  templateUrl: './customer-service.component.html',
  styleUrls: ['./customer-service.component.css']
})
export class CustomerServiceComponent implements OnInit {
 disableSubmit:boolean = false
 siteKey = environment.siteKey
 tUrl = 'https://cosmosgranite.nyc3.cdn.digitaloceanspaces.com/igmcorp/assets/images';
 cutomeoption : OwlOptions = {
    loop: true,
    margin: 10,
    dots: false,
    //animateOut: 'flipOutX',
    animateIn: 'fadeInRight',
    smartSpeed: 450,
    //default settings:
    autoplay: true,
    autoplayTimeout: 3500,
    nav: false,
    responsive: {
      0: {
        items: 1,
        margin: 0,
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  }
  contactForm =contactForm;
  message;
  loadMore;
  location = [];
    constructor(private fb: FormBuilder,  private api: ApiService, private shared: SharedService,
    private activatedRoute: ActivatedRoute,private router: Router, private _seoService: SeoServiceService,private reCaptchaV3Service: ReCaptchaV3Service) { 
      this.activatedRoute.fragment.subscribe( fragment =>{
    // this.shared.cleardata();
    this.message = undefined;
    this.loadMore = false;
    // this.getCategory();
    this.contactForm.reset();
  })
  // this.shared.cleardata();
  this.loadMore = false;
  // this.getCategory();
  this.getLocation()
  this._seoService.updateTitle('Delivering Exceptional Customer Service at the Earliest | Coalesce Quartz');
  this._seoService.updateDescription('For any guidance about quartz products, meet our experts in-person or reach us via email or call. We are there to help you select the best for your space.')
}

  submitted: boolean= false;
  ngOnInit(): void {
    this.contactForm = this.fb.group({
      first_name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      message: ['', Validators.required],
      location: ['', Validators.required],
      hp_field: [''],
    });
  }
  ngAfterViewInit(){
    // $(document).ready(function() {
    //   $('.slider4').owlCarousel();
    
    
    // })
  }
  get f() { return this.contactForm.controls; }

  onContactus(d) {
    this.submitted = true;
    this.loadMore = true;

    if (this.contactForm.invalid) {
      this.loadMore = false;
      return;
    }
    this.disableSubmit = true

    this.reCaptchaV3Service.execute(this.siteKey, 'ContactForm', (token) => {

      this.message = '';

      let obj = {
        location_name: d.location,
        Name: d.first_name,
        Email: d.email,
        Message: d.message,
        Subject: d.subject,
        website: 'coalesce-quartz',
        hp_field: d.hp_field,
        captcha: token
      }

      this.api.fetchDataIgm('contact-store-coalesce-quartz', obj, "POST").subscribe(res => {
        this.disableSubmit = false
        if (res.status == 1) {
          this.message = res.message;
          this.contactForm.reset();
          this.submitted = false;
          this.loadMore = false;
          setTimeout(() => {
            this.message = '';
          }, 3000)
        } else {
          this.message = res.message;
          this.submitted = false;
          this.loadMore = false;
        }
      })
    }, {
      useGlobalDomain: false
    });
  }

  selectlocation(value){
    localStorage.setItem('location',value);
  }

  // getCategory() {
  //   this.api.fetchData('product_category',{},'GET').subscribe(
  //     res => {
  //       if(res['status'] == 1) {
  //         this.shared.categoryList = res['category']
  //       }
  //     }
  //   )
  // }
  getLocation() {
    this.api.fetchDataIgm('allLocation-coalesce-quartz',{},'POST').subscribe(
      res => {
        if(res['status'] == 1) {
          this.location =   res['location'];
        } else {
          this.location =  [];

        }
      }
    )
  }
}
